module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD]),
      expression: "[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-danger mr-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteRouteModal
    }
  }, [_vm._v("Delete Route")])]), _vm._v(" "), _c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.name),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.tripRoute.name),
      expression: "tripRoute.name",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name",
      "required": "",
      "placeholder": "name"
    },
    domProps: {
      "value": (_vm.tripRoute.name)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tripRoute, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "name",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Name is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.approxDistance),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Approx. Distance(km) ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.tripRoute.approxDistance),
      expression: "tripRoute.approxDistance",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "approxDistance",
      "required": "",
      "placeholder": "Approx. Distance"
    },
    domProps: {
      "value": (_vm.tripRoute.approxDistance)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tripRoute, "approxDistance", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "approxDistance",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Approx. Distance is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.approxTime),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Approx. Time (in Min)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.tripRoute.approxTime),
      expression: "tripRoute.approxTime",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "max": "2880",
      "name": "approxTime",
      "required": "",
      "placeholder": "Approx. Time"
    },
    domProps: {
      "value": (_vm.tripRoute.approxTime)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tripRoute, "approxTime", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "approxTime",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Approx. Time is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "max"
    },
    slot: "max"
  }, [_vm._v("Maximum Time for a Trip is 2 days")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.status),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tripRoute.status),
      expression: "tripRoute.status"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tripRoute, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inactive"
    }
  }, [_vm._v("Inactive")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "status",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Status is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Status date is invalid")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.reportAssessment),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Report Assessment")]), _vm._v(" "), _c('input', {
    ref: "reportAssesssment",
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": _vm.onFilechanged
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "reportAssessment",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Please upload less than 3mb picture")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographical Area")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tripRoute.region),
      expression: "tripRoute.region"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "region"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tripRoute, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select G.A")]), _vm._v(" "), _vm._l((_vm.region_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                                " + _vm._s(item.value) + "\n                                            ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Geographical Area is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.startSite),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Start Location")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tripRoute.startSite),
      expression: "tripRoute.startSite"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "startSite"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tripRoute, "startSite", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.addLatLng]
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select Location")]), _vm._v(" "), _vm._l((_vm.start_site), function(item, index) {
    return _c('option', {
      key: index,
      attrs: {
        "lat": item.latitude,
        "long": item.longitude,
        "startmessageMarker": item.siteName
      },
      domProps: {
        "value": item._id
      }
    }, [_vm._v("\n                                                " + _vm._s(item.siteName) + "\n                                            ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "startSite",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Start Location is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.endSite),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("End Location")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tripRoute.endSite),
      expression: "tripRoute.endSite"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "endSite"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tripRoute, "endSite", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.addEndLatLng]
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("End Location")]), _vm._v(" "), _vm._l((_vm.end_site), function(item, index) {
    return _c('option', {
      key: index,
      attrs: {
        "endLat": item.latitude,
        "endLong": item.longitude,
        "endmessageMarker": item.siteName
      },
      domProps: {
        "value": item._id
      }
    }, [_vm._v("\n                                                " + _vm._s(item.siteName) + "\n                                            ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "endSite",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("End Location is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', {
    staticClass: "col-md-12"
  }, [_vm._v("Route Markers")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Latitude")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Longitude")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("Message")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_vm._l((_vm.tripRoute.routeMarkers), function(routes, r_id) {
    return _c('div', [_c('div', {
      staticClass: "col-sm-3"
    }, [_c('validate', {
      staticClass: "form-group required-field",
      class: _vm.fieldClassName(_vm.formstate.latitude),
      attrs: {
        "auto-label": ""
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (routes.latitude),
        expression: "routes.latitude"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": "",
        "placeholder": "68.654 N",
        "pattern": "^-?([1-8]?[1-9]|[1-9]0)\\.{1}\\d{1,6}"
      },
      domProps: {
        "value": (routes.latitude)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(routes, "latitude", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('field-messages', {
      staticClass: "form-control-feedback",
      attrs: {
        "name": "latitude",
        "show": "$touched || $submitted"
      }
    }, [_c('div', {
      attrs: {
        "slot": "required"
      },
      slot: "required"
    }, [_vm._v("Latitude is required")]), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "pattern"
      },
      slot: "pattern"
    }, [_vm._v("Invalid Input")])])], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('validate', {
      staticClass: "form-group required-field",
      class: _vm.fieldClassName(_vm.formstate.longitude),
      attrs: {
        "auto-label": ""
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (routes.longitude),
        expression: "routes.longitude"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": "",
        "placeholder": "68.654 E",
        "pattern": "^-?([1-8]?[1-9]|[1-9]0)\\.{1}\\d{1,6}"
      },
      domProps: {
        "value": (routes.longitude)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(routes, "longitude", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('field-messages', {
      staticClass: "form-control-feedback",
      attrs: {
        "name": "longitude",
        "show": "$touched || $submitted"
      }
    }, [_c('div', {
      attrs: {
        "slot": "required"
      },
      slot: "required"
    }, [_vm._v("Longitude is required")]), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "pattern"
      },
      slot: "pattern"
    }, [_vm._v("Invalid Input")])])], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4 marker"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (routes.message),
        expression: "routes.message"
      }],
      staticClass: "form-control required",
      attrs: {
        "row": "1",
        "required": "",
        "placeholder": "Route Message"
      },
      domProps: {
        "value": (routes.message)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(routes, "message", $event.target.value)
        }
      }
    })]), _vm._v(" "), ((r_id > 0 && r_id < _vm.tripRoute.routeMarkers.length - 1)) ? _c('i', {
      staticClass: "col-sm-1 fa fa-trash text-secondary",
      on: {
        "click": function($event) {
          return _vm.remove(r_id)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), _c('i', {
    staticClass: "col-sm-1 btn addbtn",
    staticStyle: {
      "height": "50px",
      "width": "75px"
    },
    on: {
      "click": function($event) {
        return _vm.add(_vm.r_id)
      }
    }
  }, [_c('h4', [_vm._v("+")])])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Route'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-4 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.updateRoute
    }
  }, [_vm._v("Update Route")])], 1)], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c261320"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/tripRoute/RouteDetail.vue
// module id = 2335
// module chunks = 1